$( document ).ready(function() {


  //Get Login status
  let loggedin = $('#loggedin').data('user');


  // always put the auto add first
  $('.cart-items').prepend($('.auto-added'));
    $.getJSON('/cart.js', function(cart) {
        //console.log(cart);
    } );
  
    // have to declair this so that the functions can see it
    var $cartItem;
    

  ///////////////////////////////////////////////
  // MAKE MONEY ///////////////////////////////////
  ///////////////////////////////////////////////
  function makeMoney(money){
    return newMoney = '$' + (money/100).toFixed(2);
  }


  ///////////////////////////////////////////////
  // AUTO ADD ///////////////////////////////////
  ///////////////////////////////////////////////
  function validateAutoAdd(){
    let requiredProductId = $('#requiredProduct').data('id');
    var coffee_count = 0;
    var canister_count = 0;
    $.getJSON('/cart.js', function(cart) {
      for (item in cart.items) {
        if (cart.items[item].product_type.includes('Coffee')){
          coffee_count += 1;
        }
        if (cart.items[item].id == requiredProductId){
          canister_count += 1;
        }
      }
      if ( coffee_count >= 1 ){
        if(canister_count <= 0){
          var updateData = {}
          updateData[requiredProductId] = 1;
          
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              updates: updateData
            },
            dataType: 'json',
            success: function(cart){ 
              for(var i=0; i < cart.items.length; i++){
                var item = cart.items[i];
                if( item.id == requiredProductId){
                  
                  let newDiv = '';
                  newDiv += '<tr class="cart-item auto-added" data-num="0" id="CartItem-auto" data-id="'+requiredProductId+'" data-price="'+makeMoney(item.price)+'">';
                  newDiv += '  <td class="cart-item__media">';
                  newDiv += '     <div class="cart-item__image-container gradient global-media-settings">';
                  newDiv += '        <img src="'+item.image+'" class="cart-item__image" alt="Ozark Compost and Swap" loading="lazy" width="150" height="100" />';
                  newDiv += '     </div>';
                  newDiv += '  </td>';
                  newDiv += '  <td class="cart-item__details">';
                  newDiv += '   <span class="cart-item__name">'+item.product_title+'</span>';
                  newDiv += '    <p>If you are starting your first coffee and compost subscription, you will need to have a coffee canister. This is a one-time charge.</p>';
                  newDiv += '    <div class="remove-this-item" id="Remove-1" data-index="1">';
                  newDiv += '        <span class="remove-btn" aria-label="Remove">No thanks. I already have one.</span>';
                  newDiv += '    </div>';
                  newDiv += '  </td>';
                  newDiv += '  <td class="cart-item__totals right small-hide">';
                  newDiv += '    <div class="cart-item__price-wrapper">';
                  newDiv += '        <span class="price price--end">'+makeMoney(item.price)+'</span>';
                  newDiv += '    </div>';
                  newDiv += '  </td>';
                  newDiv += '</tr>';
                  $('.cart-items tbody').prepend(newDiv);
                }
              }
              realCartCount();
              resetCart();
            },
            error: function(err){ 
              console.error('Booo!', err)
            }
          });

        }
      } else {
        let existingCanister = $('.cart-item.auto-added');
        let existingCanisterID = $('.cart-item.auto-added').data('id');
        let removeArr = new Array();
        let removeItem = new Array('"'+requiredProductId+':0');
        removeArr.push(removeItem);

        // Remove all canisters
        var updateData = {}
        for(var i=0; i < cart.items.length; i++){
          var item = cart.items[i];
          if( item.id == requiredProductId){
            updateData[item.key] = 0;
          }
        }
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          success: function(cart){ 
            $('.cart-item.auto-added').remove();
            realCartCount();
            resetCart();
          },
          error: function(err){ 
            console.error('Booo!', err) 
          }
        });
      }
    });
  }

  validateAutoAdd();

  ///////////////////////////////////////////////
  // CLEANUP EXTRA SUBSCRIPTIONS ////////////////
  ///////////////////////////////////////////////
  function cleanUpExtras() {
    $.getJSON('/cart.js', function(cart) {
      for (item in cart.items) {
        let extraQty = cart.items[item].quantity;
        let extraId = cart.items[item].id;
        let thisProductType = cart.items[item].product_type;
        let thisProductTest = thisProductType.includes("Compost");
        if (thisProductTest && extraQty >= 2){
          itemsArray = [extraId];
          // Load this item into data for removal
          var qty = 1;
          var data = { updates: {} };
          for (i = 0; i < itemsArray.length; i++) {
            data.updates[itemsArray[i]] = qty;
          }
          // Use array to remove
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function(response) { 
              realCartCount();
            }
          });
        }
      }
    });
  }
  cleanUpExtras();

  ///////////////////////////////////////////////
  // RESET CART /////////////////////////////////
  ///////////////////////////////////////////////
  function resetCart() {
    //console.log(cart);
    $.getJSON('/cart.js', function(cart) {
      for (item in cart.items) {
        //console.log(cart.items[item]);
        var lineID = cart.items[item].id;
        var linePrice = cart.items[item].final_line_price;
        $('tr[data-idu="'+lineID+'-'+item+'"]').find('.price--end').text(makeMoney(linePrice));
        //console.log(linePrice)
      }
      $('.totals__subtotal-value').text(makeMoney(cart.total_price) + ' USD');
    
    } );
  }
  ///////////////////////////////////////////////
  // QUANTITY BUTTONS ///////////////////////////
  ///////////////////////////////////////////////
    $('.quantity_btn').on('click', function(e) {
      e.preventDefault();
      var $cartItem = $(this).closest('tr');
      var variant_id = $cartItem.data('id');
      var quantity = '';
      var orr_quantity = parseInt($(this).closest('tr').find('.quantity__input').val());
      
      // figure out which btn was clicked
      if( $(this).hasClass('btn-plus')) {
        quantity = orr_quantity + 1;
      } else {
        if( orr_quantity === 1){
          // Don't let it go to 0.
        quantity = 1;
        } else {
        quantity = orr_quantity - 1;
        }
      }
    $(this).closest('tr').find('.quantity__input').val(quantity);
      // must be declaired first
      var itemsArray = [variant_id];
      var data = { updates: {} };
      data.updates[itemsArray[0]] = quantity;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(response) { 
          resetCart(response);
          realCartCount();
        },
        error: function() {
          console.log("error");
        }

      });
  
    });
  
  
  ///////////////////////////////////////////////
  // REMOVE BUTTONS /////////////////////////////
  ///////////////////////////////////////////////
  
  $(document).on('click', '.remove-this-item', function(e) {
    let tr = $(this).closest('tr');
    let thisItemId = tr.data('id');
  
    itemsArray = [thisItemId];

  
    var qty = 0;
    var data = { updates: {} };
  
    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
  
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(response) {
          realCartCount();
          tr.remove();
          resetCart();
        }
    });

    realCartCount();
    $.getJSON('/cart.js', function(cart) {
      if(cart.items.length == 0){
          window.location.href= '/cart';
      }
    });
      
  });
  


  // Testing adding a subscription to cart automatically

  $('.add-on-item').on('click', function(e) {
    let product_id = $(this).data('id');
    let selling_plan = $(this).data('selling-id');
    let product_title = $(this).data('title');
    let product_img= $(this).data('title');

    let payloadData = {
      'items': [{
        'id': product_id,
        'quantity': 1,
          "selling_plan": selling_plan,
        }]
      };
      

      

      fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payloadData)
    })
    .then(response => {
      return response.json();
      console.error('Error:', response);
    })
    .then(response => {
      console.log('Success:', response);

      for(var i=0; i < response.items.length; i++) {
        var item = response.items[i];
        if( item.variant_id == product_id){
          
          let newDiv = '';
          newDiv += '<tr class="cart-item" data-num="1000" data-id="'+product_id+'" data-price="'+item.price+'">';
          newDiv += '    <td class="cart-item__media">';
          newDiv += '        <div class="cart-item__image-container gradient global-media-settings">';
          newDiv += '        <img src="'+item.image+'" class="cart-item__image" alt="" loading="lazy" width="150" height="150">';
          newDiv += '        </div>';
          newDiv += '    </td>';
          newDiv += '    <td class="cart-item__details">';
          newDiv += '        <a href="'+item.url+'" class="cart-item__name">'+item.product_title;
          newDiv += '        </a>';
          newDiv += '        <div class="product-option">'+makeMoney(item.price)+'</div><dl></dl>';
          newDiv += '        <p class="product-option">'+item.selling_plan_allocation.selling_plan.name+'</p>';
          newDiv += '    </td>';
          newDiv += '    <td class="cart-item__quantity">';
          newDiv += '        <div class="cart-item__quantity-wrapper">';
          newDiv += '        <label class="visually-hidden" for="Quantity-10000">Quantity</label>';
          newDiv += '        <div class="remove-this-item" id="Remove-10000" data-index="10000">';
          newDiv += '            <span class="button button--tertiary" aria-label="Remove '+item.product_title+'">';
          newDiv += '            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg>';
          newDiv += '            </span>';
          newDiv += '        </div>';
          newDiv += '        </div>';
          newDiv += '   </td>';
          newDiv += '    <td class="cart-item__totals right small-hide">';
          newDiv += '        <div class="cart-item__price-wrapper"><span class="price price--end">'+makeMoney(item.price)+'</span></div>';
          newDiv += '    </td>';
          newDiv += '</tr>';
          $('.cart-items tbody').append(newDiv);
        }
      }
      validateAutoAdd();
      realCartCount();
      $('.add-on-group').removeClass('show-this');
      $('.toggle-add-on').text('+ Add Subscription Coffee');

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });
  
});

// Toggle to show add ons

if($('.add-on-group').hasClass('show-this')){
  $('.toggle-add-on').text('');
}
$('.toggle-add-on').on('click', function(e) {
  if($('.add-on-group').hasClass('show-this')){
    $('.add-on-group').removeClass('show-this');
    $(this).text('+ Add Subscription Coffee');
  } else {
    $('.add-on-group').addClass('show-this');
    $(this).text('');
  }
});

// Toggle to show weekly or biweekly

$('.frequency-toggle').on('click', function(e) {
  if($(this).hasClass('weekly-on')){
    $(this).removeClass('weekly-on');
    $(this).addClass('biweekly-on');
    $('.label-weekly').hide();
    $('.label-biweekly').show();

    $('.biweekly-addons').addClass('show-this');
    $('.weekly-addons').removeClass('show-this');

  } else if ($(this).hasClass('biweekly-on')){
    $(this).addClass('weekly-on');
    $(this).removeClass('biweekly-on');
    $('.frequency-toggle .label-biweekly').hide();
    $('.frequency-toggle .label-weekly').show();

    $('.weekly-addons').addClass('show-this');
    $('.biweekly-addons').removeClass('show-this');
  }
});

